// PricingSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/controls/FormInput";
import PriceTypes from "../../../components/dropdowns/PriceTypes";
import Toggle from "../../../components/ui/Toggle";
import { CurrencyDollarIcon } from "@heroicons/react/24/solid";

const PricingSection = ({ formData, onChange, priceTypesList, isService }) => {
  const { t } = useTranslation();

  const handleToggle = () => {
    onChange("isVisible", !formData.isVisible);
  };

  const onPriceTypeChanged = (priceTypeId) => {
    onChange("priceTypeId", priceTypeId);
  };

  const handlePriceChange = (name, value) => {
    const regex = /^\d{0,8}([.,]\d{0,2})?$/;

    if (!regex.test(value) && value !== "") {
      return; // Ignore invalid input
    }

    onChange(name, value); // Enregistre dans formData
  };

  return (
    <section className="bg-white rounded-lg shadow p-6 space-y-4">
      <h2 className="text-xl font-bold text-primary">{t("modal.pricing")}</h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
        <FormInput
          label={t("modal.price")}
          name="price"
          type="text"
          prefix="$"
          value={formData.price}
          onChange={handlePriceChange}
          required
          onFocus={(e) => e.target.select()}
          icon={<CurrencyDollarIcon className="w-5 h-5 text-gray-500" />}
        />

        <PriceTypes
          id={formData.priceTypeId}
          onSelect={onPriceTypeChanged}
          priceTypesList={priceTypesList}
          isService={isService}
        />

        <Toggle
          isEnabled={formData.isVisible}
          onToggle={handleToggle}
          labelOn={t("products.isVisibleToSell")}
          labelOff={t("products.isNotVisibleToSell")}
          colorActive="bg-green-500"
          colorInactive="bg-red-500"
          className="toggle-lg"
          title={t("products.visibility")}
          name="isVisible"
        />
      </div>
    </section>
  );
};

export default PricingSection;
